import { render, staticRenderFns } from "./admCoordinadores.vue?vue&type=template&id=c8e53980&scoped=true"
import script from "./admCoordinadores.vue?vue&type=script&lang=js"
export * from "./admCoordinadores.vue?vue&type=script&lang=js"
import style0 from "./admCoordinadores.vue?vue&type=style&index=0&id=c8e53980&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e53980",
  null
  
)

export default component.exports